import Model from '../Model'

export default class WithdrawalCryptoWallet extends Model {
    resource() {
        return 'admin/crypto-wallet/withdrawals'
    }
}
